import script from "./ImageLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageLoader.vue?vue&type=script&setup=true&lang=ts"

import "./ImageLoader.vue?vue&type=style&index=0&id=81128738&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81128738"]])

export default __exports__